// extracted by mini-css-extract-plugin
export var finish = "style-module--finish--3QseT";
export var finish_head_suptitle = "style-module--finish_head_suptitle--2ECfC";
export var finish_head_title = "style-module--finish_head_title--1zbJP";
export var finish_main = "style-module--finish_main--2MsSS";
export var finish_main_title = "style-module--finish_main_title--3RXQM";
export var finish_main_links = "style-module--finish_main_links--eOZCt";